import * as actionTypes from "../actions/actionTypes";
import {
    updateObject
} from "../Utility";

const initialState = {
    resources: [],
    reservations: [],
    openTime: 7,
    closeTime: 7
};

const setResources = ( state, action ) => {
    return updateObject( state, { resources: action.resources, } );
};

const setReservations = ( state, action ) => {
    return updateObject( state, { reservations: action.reservations, } );
};

const setLabHours = ( state, action ) => {
    return updateObject( state, { openTime: action.open, closeTime: action.close } );
}

const reducer = ( state = initialState, action ) => {
    switch( action.type ) {
        case actionTypes.SET_RESOURCES: return setResources( state, action );
        case actionTypes.SET_RESERVATIONS: return setReservations( state, action );
        case actionTypes.LAB_HOURS_GOT: return setLabHours( state, action );
        default:
            return state;
    }
};

export default reducer;